export default __webpack_public_path__ + "static/media/home-active.9cab1768.webp";